import { Md5 } from 'ts-md5/dist/md5';

export class LoggedUser {
  name: string;
  email: string;
  info: any;
  picture: string;

  get id() {
    return this.info.uid;
  }

  get pictureUrl() {
    if (!this.picture || this.picture === "") {
      if (this.email && this.email !== "") {
        const str: string = Md5.hashStr(this.email) as string;
        this.picture = `https://www.gravatar.com/avatar/${str}`;
      }
    }

    return this.picture;
  }
}
